import { Spinner } from '@telefonica/mistica';
import { AxiosError, AxiosResponse } from 'axios';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { generateJwe } from '../../../services/LoginService';
import navigateParams from '../../../utils/navigation/navigateParams';
import { setInfoError } from '../../../utils/dataTransformation/errorMesssages';
import { ErrorStateUIData } from '../../../models/interfaces';
import { getEnv } from '../../../utils/dataTransformation/environments';

const LoginSSO: React.FC = () => {
    const { t } = useTranslation();
    const sendToNative = (description: string, type: string, subtitle: string, err?: ErrorStateUIData) => {
        const queryParams = {
            state: description,
            title: t('profileFeedbackErrorTitle'),
            subtitle: err?.localizedDescription,
            errorCode: err ? `${t('codeError')}: #${err.id}` : '',
        };
        const storage = {};
        navigateParams(type, '', queryParams, storage, '');
    };

    useEffect(() => {
        generateJwe()
            .then((response: AxiosResponse) => {
                const jwe = response.data.jwe;
                window.location.href = `${getEnv('VITE_LOGIN_SSO_URL')}?jwt=${jwe}&redirect_url=${getEnv('VITE_LOGIN_SSO_CALLBACK')}`;
            })
            .catch((error: AxiosError) => {
                sendToNative('ERROR', 'feedback-error', 'subtitle', setInfoError(error));
            });
    }, []);

    return (
        <>
            <div className='c-spinner'>
                <Spinner size={24} />
                <span className='c-spinner-overlay'></span>
            </div>
        </>
    );
};

export default LoginSSO;
